import roles from './roles.js'
import menuControl from '@/app/shared/components/lists/menu.vue'
import pages from './pages.js'

const bfPages = new pages();

export default {
  components: {
    menuControl
  },
  data() {
    return {
      roles,
      editItems : bfPages.getMenuItems(),
      adminItems : bfPages.getAdminMenuItems(),
      reportItems : [ 
        {
          roles : roles.readers,
          icon : "BarChart2Icon",
          to : "/drilling/optimizedReport",
          i18nTitle : "Drilling.Reports.Optimized"
        },
        {
          roles : roles.readers,
          icon : "BarChart2Icon",
          to : "/drilling/drillingAnalytics",
          i18nTitle : "Drilling.Reports.Analytics"
        }

      ],
      explorationItems : [ 
        {
          roles : roles.readers,
          icon : "BarChart2Icon",
          to : "/drilling/dashboard",
          i18nTitle : "Drilling.Reports.Dashboard"
        }
      ]
    }
  }
}